import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";
import ta from "../locales/ta.json";
import hi from "../locales/hi.json";
import ml from "../locales/ml.json";
import te from "../locales/te.json";
import kn from "../locales/kn.json";
import ar from "../locales/ar.json";
import fr from "../locales/fr.json";
import de from "../locales/de.json";
import es from "../locales/es.json";
import zhCN from "../locales/zh-CN.json";
import ja from "../locales/ja.json";
import ru from "../locales/ru.json";

const resources = {
  en: { translation: en },
  ta: { translation: ta },
  hi: { translation: hi },
  ml: { translation: ml },
  te: { translation: te },
  kn: { translation: kn },
  ar: { translation: ar },
  fr: { translation: fr },
  de: { translation: de },
  es: { translation: es },
  "zh-CN": { translation: zhCN },
  ja: { translation: ja },
  ru: { translation: ru },
};

const supportedLanguages = Object.keys(resources);
const storedLanguage =
  localStorage.getItem("appLanguage") || localStorage.getItem("i18nextLng");
const initialLanguage = supportedLanguages.includes(storedLanguage)
  ? storedLanguage
  : "en";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: "en",
    supportedLngs: supportedLanguages,
    interpolation: { escapeValue: false },
    returnEmptyString: false,
    initImmediate: false,
  });

export default i18n;
